import {Injectable, Injector} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {environment} from '../environments/environment';
import {map} from 'rxjs/operators';
import {AuthService} from './user/auth.service';
import {AccessTokenService} from './user/access-token.service';

@Injectable({
  providedIn: 'root'
})
export class AuthedApiService {

  authedOptions: any;
  authedMultipartOptions: any;

  constructor(private _http: HttpClient,
              private injector: Injector) { }

  getAuth() {
    const auth = this.injector.get(AccessTokenService);
    return 'Bearer ' + auth.token;
  }

  getHttp() {
    const auth = this.injector.get(AccessTokenService);
    const jwt = auth.token;

    this.authedOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': this.getAuth(),
        'Access-Control-Allow-Origin': '*',
        'observe': 'response'
      })
    };

    this.authedMultipartOptions = {
      headers: new HttpHeaders({
        'Authorization': this.getAuth(),
        'Access-Control-Allow-Origin': '*',
        'observe': 'response'
      })
    };
  }

  validateLogin(payload) {
    return this._http.post(environment.identityHost + '/auth/signin', payload, {
          headers: new HttpHeaders({
            'Content-Type': 'application/json',
            'observe': 'response'
          })
        })
        .pipe(map(response => response));
  }

  validatePartnerEmailWithShortCode(partner, email) {
    this.getHttp();
    return this._http.post(environment.identityHost + '/auth/email/validate', {email: email, environment: partner}, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'observe': 'response'
      })
    })
        .pipe(map(res => res));
  }

  getAccountUserProfile() {
    this.getHttp();
    return this._http.get(environment.identityHost + '/user/profile', this.authedOptions)
        .pipe(map(response => response));
  }

  getUserAccountPermissions() {
    this.getHttp();
    return this._http.get(environment.identityHost + '/user/permissions', this.authedOptions)
        .pipe(map(response => response));
  }

  getCoreApi(apiName, apiVersion, query = '', params = {}) {
    this.getHttp();
    if (params && Object.keys(params).length !== 0) {
      this.authedOptions['params'] = params;
    }
    return this._http.get(environment.coreHost + '/' + apiVersion + '/' + apiName + (query ? ('?' + query) : ''), this.authedOptions)
        .pipe(map(response => response));
  }

  getRawDataKeyTypes() {
    this.getHttp();
    return this._http.get(environment.coreHost + '/v1/rawDataTypes', this.authedOptions)
        .pipe(map(response => response));
  }

  postCoreApi(apiName, apiVersion, payload) {
    this.getHttp();
    return this._http.post(environment.coreHost + '/' + apiVersion + '/' + apiName, payload, this.authedOptions).pipe(map(res => res));
  }

  postCoreApiMultipart(apiName, apiVersion, payload) {
    this.getHttp();
    return this._http.post(environment.coreHost + '/' + apiVersion + '/' + apiName, payload, this.authedMultipartOptions).pipe(map(res => res));
  }

  getApiJoinsData(apiName, apiVersion) {
    this.getHttp();
    return this._http.get(environment.coreHost + '/v1/apijoins/' + apiVersion + '/' + apiName, this.authedOptions)
        .pipe(map(response => response));
  }

  submitApiJoinsInsert(apiName, apiVersion, payload) {
    this.getHttp();
    return this._http.post(environment.coreHost + '/v1/apijoins-insert/' + apiVersion + '/' + apiName, payload, this.authedOptions)
        .pipe(map(response => response));
  }

  submitApiJoinsEdit(apiName, apiVersion, payload) {
    this.getHttp();
    return this._http.post(environment.coreHost + '/v1/apijoins-edit/' + apiVersion + '/' + apiName, payload, this.authedOptions)
        .pipe(map(response => response));
  }

  submitApiJoinsDelete(apiName, apiVersion, payload) {
    this.getHttp();
    return this._http.post(environment.coreHost + '/v1/apijoins-delete/' + apiVersion + '/' + apiName, payload, this.authedOptions)
        .pipe(map(response => response));
  }

  createEnvironment(payload) {
    this.getHttp();
    return this._http.post(environment.accountsHost + '/v1/environment', payload, this.authedOptions)
        .pipe(map(response => response));
  }

  getPartnerEnvironments(partner) {
    this.getHttp();
    return this._http.get(environment.coreHost + '/v1/' + partner + '/environments', this.authedOptions)
        .pipe(map(response => response));
  }

  dataTransformationWithCore(payload) {
    this.getHttp();
    if (payload) {
      payload['servers'] = {
        services: environment.apihostname,
        kinger: environment.kingerHostName,
        kong: environment.adminGatewayHost,
        'python-services' : environment.pythonServerHostName
      };
    }
    return this._http.post(environment.coreHost + '/v1/database-transform', payload, this.authedOptions)
        .pipe(map(response => response));
  }

  getDeploymentPlanForCOBOL(payload, apikey, transformOption) {
    const formData = new FormData();
    // formData.append('file', payload);

    formData.append('file', new Blob([payload], {
      type: 'text/x-cobol'
    }));
    formData.append('pythonHost', environment.pythonServerHostName);
    const httpOptions = {
      headers: new HttpHeaders({
        'Authorization': this.getAuth(),
        'apikey': apikey,
        'Access-Control-Allow-Origin': '*'
      }),
    };

    return this._http.post(environment.coreHost + '/v1/cobol-plan?transformOption=' + transformOption, formData, {headers: httpOptions.headers})
        .pipe(map(res => res));
  }

  getAccelerators(payload) {
    if (payload) {
      payload['servers'] = {
        services: environment.apihostname,
        kinger: environment.kingerHostName,
        kong: environment.adminGatewayHost,
        'python-services': environment.pythonServerHostName
      };
    }
    return this._http.post(environment.integrationsHost + '/v2/accelerators', payload, this.authedOptions)
        .pipe(map(res => res));
  }

  upsertIndividualAccelerators(payload) {
    if (payload) {
      payload['servers'] = {
        services: environment.apihostname
      };
    }
    return this._http.post(environment.integrationsHost + '/v1/upsert-partner-accelerator', payload, this.authedOptions)
        .pipe(map(res => res));
  }
}
